/**
 * Aide contextuelle — Veille stratégique
 */

const veilleHelp = {
  '/veille': {
    title: 'Veille stratégique',
    user: [
      {
        heading: 'A quoi sert cette page ?',
        content: `Dashboard de veille stratégique METERIS : flux quotidien d'actualités filtrées selon les thèmes configurés (cybersécurité, IA, concurrents, partenaires). Alimenté par un pipeline n8n qui agrège RSS + sources web via Cloudflare Worker puis stocke dans MongoDB.`,
      },
      {
        heading: 'Les filtres',
        content: `**Période** : aujourd'hui, 7 jours, 30 jours, personnalisé.\n**Catégorie** : cybersécurité, IA, concurrents, partenaires, autres.\n**Score minimal** : seuls les articles avec un score >= seuil sont affichés (par défaut 60/100).`,
      },
      {
        heading: 'Actions par article',
        content: `**Lire** : ouvre l'article source dans un nouvel onglet.\n**Archiver** : masque l'article des futures vues.\n**Partager** : génère un lien interne pour partager avec l'équipe.\n**Convertir en idée** : envoie vers le module Assistant > Idées (pour transformation en action commerciale).`,
      },
    ],
    admin: [
      {
        heading: 'Pipeline n8n',
        content: `Workflow ID \`VCoExae7SaW0pFch\`. Collecte quotidienne 6h → scraping via Cloudflare Worker \`veille-proxy.workers.dev\` → Ollama local pour scoring/résumé → POST \`/api/veille/webhook\` → stockage MongoDB \`veille_quotidienne\`.`,
      },
      {
        heading: 'Endpoints',
        content: `\`GET /api/veille\` — Liste articles (filtres période/catégorie/score).\n\`POST /api/veille/action\` — Archiver, convertir, partager.\n\`POST /api/veille/webhook\` — Réception batch depuis n8n (secret N8N_SECRET_VEILLE).`,
      },
      {
        heading: 'Sources',
        content: `Configurées dans le workflow n8n : feeds RSS + scraping listes de surveillance. Pour ajouter une source, modifier directement le workflow n8n (pas de UI dans le portail).`,
      },
    ],
  },
};

export default veilleHelp;
